import { AppState } from '@/stores/App/state'

export type AppGetters = {
  [K in keyof AppState]: (state: AppState) => AppState[K]
}

export default {
  hasError: (state: AppState) => state.hasError,
  errorMessage: (state: AppState) => state.errorMessage,
  errorSubMessage: (state: AppState) => state.errorSubMessage,
  errorDetails: (state: AppState) => state.errorDetails,
  visibleTerminal: (state: AppState) => state.visibleTerminal,
  leaveToRoute: (state: AppState) => state.leaveToRoute,
  isOnTour: (state: AppState) => state.isOnTour,
} satisfies AppGetters
